import React, { Component } from 'react';
import './RecurringActivity.scss';
import { ModalBody, ClosePopup, ModalC } from '../../../../../components/UI/Modals/Modals';
import { FormGroupRow, FormGroups } from '../../../../../components/ReusableComponents/FormGroups/FormGroups';
import { CustomButton } from '../../../../../components/UI/Button/button';
import { CustomDate } from '../../../../../components/UI/FormInput/FormInput';
import { weekDays, staticVar } from '../../../../../services/Constants';
import { setMaxDate } from '../../../../../services/CommonFunction';
import { checkDate, setMonths } from '../../../List/CommonActivityFunc';
import { errorHandler } from '../../../../../components/UI/selector';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class RecurringActivity extends Component {

    state = {
        weekDays: weekDays,
        recurring: staticVar.oneDay,
        weeks: [],
        startDate: new Date(),
        minDate: new Date(),
        endDate: new Date(),
        maxDate: false,
        days: 7,
        available: []
    }

    componentDidMount = async () => {
        await this.setState({
            recurring: this.props.schedule_type,
            weeks: this.props.repeat_on_week_days,
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            maxDate: checkDate(this.props.startDate, this.props.endDate),
        })
        this.setState({
            days: this.diffDate()
        })
    }

    selectDays = (el) => {
        if (el === staticVar.daily) {
            this.setState({
                recurring: el,
                weeks: [0, 1, 2, 3, 4, 5, 6]
            })
        } else {
            let weeks = [...this.state.weeks];
            const cond = weeks.includes(el);
            if (cond) {
                weeks = weeks.filter(e => e !== el)
            } else {
                weeks.push(el)
            }
            this.setState({
                recurring: weeks.length === 7 ? staticVar.daily : weeks.length ? staticVar.weekly : staticVar.oneDay,
                weeks: weeks
            })
        }
    }

    dateChangeHandler = async (el, status) => {
        await this.setState({
            [status]: el
        })

        await this.setState({
            maxDate: checkDate(this.state.startDate, this.state.endDate),
            days: this.diffDate()
        })
    }

    diffDate = () => {
        const date1 = new Date(this.state.startDate);
        const date2 = new Date(this.state.endDate);
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        let start = 0;
        if (diffDays < 7) {
            start = date1.getDay();
        }
        let available = [];
        let weeks = [];
        for (let x = 0; x < (diffDays > 7 ? 7 : diffDays); x++) {
            if (start + x === 7) {
                start = 0;
            }
            available.push(start + x);
            if (this.state.weeks.includes(start + x)) {
                weeks.push(start + x);
            }
        }
        this.setState({
            available: available,
            weeks: weeks,
        })
        return diffDays;
    }

    clear = () => {
        this.setState(prevState => ({
            recurring: staticVar.oneDay,
            weeks: [],
            startDate: this.props.startDate,
            endDate: prevState.maxDate ? setMonths(this.props.startDate) : this.props.endDate,
            maxDate: false
        }))
    }

    close = () => {
        const data = {
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            schedule_type: this.props.schedule_type,
            repeat_on_week_days: this.props.repeat_on_week_days,
        }
        this.props.done(data);
        ClosePopup();

    }

    done = () => {
        const data = {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            schedule_type: this.state.recurring,
            repeat_on_week_days: this.state.weeks.sort((a, b) => a - b),
        }
        this.props.done(data);
        ClosePopup();
    }

    render() {
        const { weekDays, recurring, startDate, endDate, minDate, weeks, maxDate, days, available } = this.state;
        const weekDay = Object.keys(weekDays).map((el, index) => {
            if (index === 0) {
                return <DayDesign disable={available.length && available.includes(weekDays[el].value)} click={this.selectDays} key={index} active={weeks.length && weeks.includes(weekDays[el].value)} text="Repeat on" {...weekDays[el]} />
            } else {
                return <DayDesign disable={available.length && available.includes(weekDays[el].value)} click={this.selectDays} key={index} active={weeks.length && weeks.includes(weekDays[el].value)} {...weekDays[el]} />
            }
        })



        return (
            <React.Fragment>
                <div className="oval" onClick={this.close}>
                    <FontAwesomeIcon icon={faTimes} />
                </div>
                <ModalC>
                    <ModalBody>
                        <div className="recurringActivity">
                            <div className="field">
                                <DayDesign click={this.selectDays} disable={days > 6} active={recurring === staticVar.daily} text="Frequency" day="Daily" value={staticVar.daily} />
                                <span className="or">or</span>
                                {weekDay}
                            </div>
                            <FormGroupRow>
                                <FormGroups>
                                    <CustomDate label="Start Date" date={startDate} minDate={minDate} maxDate={endDate} handler={this.dateChangeHandler} stateKey="startDate" />
                                </FormGroups>
                                <FormGroups>
                                    <CustomDate label="End Date" date={endDate} minDate={startDate} maxDate={setMaxDate(startDate, 3)} handler={this.dateChangeHandler} stateKey="endDate" />
                                    {maxDate && <span className="error">{`${errorHandler('maxDate')}`}</span>}
                                </FormGroups>
                            </FormGroupRow>
                            <div className="submit_button">
                                <CustomButton clas="cancelButton" click={this.clear} label='Clear' condition={true} />
                                <CustomButton click={this.done} label='Done' condition={!maxDate && weeks.length} />
                            </div>
                        </div>
                    </ModalBody>
                </ModalC>
            </React.Fragment>
        )
    }
}

const DayDesign = (props) => {
    return (
        <div className="days_div">
            {props.text && <span className="text">{props.text}</span>}
            <div className={props.disable ? props.active ? "days active" : "days" : "days disable"} onClick={() => props.disable ? props.click(props.value) : null}>
                {props.day}
            </div>
        </div>
    )
}